import React from 'react';
import AssessmentsView from '../Assessments/AssessmentsView';
import { useResolvedPath } from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';

function CMI5Assessment({
    companyId,
    uniqueId,
    availableLanguages,
}) {

    const resolved = useResolvedPath('.');
    const baseUrl = resolved.pathname;
    const { cmi5Store } = useStores();
    const { cmiUser } = cmi5Store;


    return (
        <AssessmentsView
            parentUrl={baseUrl}
            availableLanguages={availableLanguages}
            companyId={companyId}
            currentUser={cmiUser}
            assessmentId={uniqueId}
            assessmentStore={cmi5Store}
            questionStore={cmi5Store}
            language={cmi5Store.language}
            showCloseButton={false}
            onClose={() => {
                cmi5Store.rxd.ConcedeControl();
            }}
            isScorm={true}
        />
    );
}

export default CMI5Assessment;
